import React, { useState, useEffect } from "react";
import SideBar from "../../../components/sidebar";
import Header from "../../../components/header";
import "../../../assets/CSS/dashboard.css";
import "../../../assets/CSS/forms.css";
import MonthlyReport from "./monthly-report-table";
import API_BASE_URL from "../../../config";

function MonthlyProjectProgressReport() {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [report, setReport] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (!query) {
      setSuggestions([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      fetch(`${API_BASE_URL}/api/project-options?query=${query}`)
        .then((res) => res.json())
        .then((data) => {
          setSuggestions(data.projects.map((d) => d.name));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [query]);

  const handleInput = (e) => {
    setQuery(e.target.value);
    setReport(false);
    setButtonClicked(false);
  };

  return (
    <div>
      {loader && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
      <SideBar />
      <div className="main-content">
        <Header />

        <div id="form-content">
          <div id="form-header" style={{ textTransform: "uppercase" }}>
            <p>Monthly Project Progress Report</p>
          </div>
          <hr />
          <form id="form">
            <div id="form-input">
              <label>
                Project Name<span className="required">*</span>
              </label>
              <input
                type="text"
                name="project"
                autoComplete="off"
                placeholder="Select Project Name"
                list="project-options"
                value={query}
                onChange={(e) => handleInput(e)}
                required
              />
              <datalist id="project-options">
                {suggestions.map((option, index) => (
                  <option key={index} value={option} />
                ))}
              </datalist>
            </div>
            <div id="form-input">
              <label>
                Month<span className="required">*</span>
              </label>
              <input
                type="month"
                name="month"
                autoComplete="off"
                required
                onChange={() => setButtonClicked(false)}
              />
            </div>
          </form>
          <div className="button">
            <button
              type="button"
              className="btn"
              id="search"
              onClick={() => {
                setReport(true);
                setLoader(true);
                setButtonClicked(true);
              }}
              disabled={buttonClicked}
            >
              SEARCH
            </button>
          </div>
        </div>
        {report && (
          <MonthlyReport
            project={query}
            month={document.querySelector('input[name="month"]').value}
            setLoader={setLoader}
          />
        )}
      </div>
    </div>
  );
}

export default MonthlyProjectProgressReport;
